import { render } from "./ProdSubCategoryModal.vue?vue&type=template&id=78d8b436&ts=true"
import script from "./ProdSubCategoryModal.vue?vue&type=script&lang=ts"
export * from "./ProdSubCategoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__